import { render, staticRenderFns } from "./PageBuilderHeadingWidget.vue?vue&type=template&id=4c348581"
import script from "./PageBuilderHeadingWidget.vue?vue&type=script&lang=js"
export * from "./PageBuilderHeadingWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports